import { Box, CircularProgress, Container, Fab, Link, Stack, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { getSingleLoadingSelector } from '@ro-loading';
import { FC, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MemeList } from './components';
import { sortedFeedMemeAction } from './meme.action';
import { ModType } from '../mod/mod.types';

export const MemeListPage: FC = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => getSingleLoadingSelector(state, 'feedSortedMeme'));

  useEffect(() => {
    dispatch(sortedFeedMemeAction.started());
  }, []);

  return (
    <Container sx={{ position: 'relative' }}>
      <Typography sx={{ marginBottom: '2rem' }} variant="h2">
        Список мемов
      </Typography>
      {/* <Stack spacing={4} direction="row">
        <Link href="/meme/mods">
          <Typography variant="body1">Моды</Typography>
        </Link>
        <Link href="/meme/seeds">
          <Typography variant="body1">Сиды</Typography>
        </Link>
        <Link href="/meme/skins">
          <Typography variant="body1">Скины</Typography>
        </Link>
        <Link href="/meme/maps">
          <Typography variant="body1">Карты</Typography>
        </Link>
      </Stack> */}
      {isLoading ? (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CircularProgress />
        </Box>
      ) : (
        <MemeList />
      )}
      <Fab
        sx={{ position: 'fixed', bottom: '4rem', right: '4rem', zIndex: 2000 }}
        component={Link}
        href="/meme/create"
        target="_blank"
        rel="noopener noreferrer"
        size="large"
        color="primary"
      >
        <Add />
      </Fab>
    </Container>
  );
};
